import { Injectable, inject } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AppStateHolder } from '../shared/app-state.holder';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  jwtHelper = inject(JwtHelperService);
  private _appStateHolder = inject(AppStateHolder);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  tokenIsValid(): boolean {
    let authToken = this._appStateHolder.getCookie('authToken');

    if (!authToken)
      return false;

    if (!this._appStateHolder.validateJWT(authToken))
      return false;

    return !this.jwtHelper.isTokenExpired(authToken);
  }
}
